<script lang="ts" setup>
import { onMounted, ref } from 'vue'

defineProps<{
  isOpen: boolean
}>()

const el = ref<HTMLElement | null>(null)

let contentHeight = 0

onMounted((): void => {
  if (el.value) {
    contentHeight += el.value?.scrollHeight
  }
})
</script>

<template>
  <div ref="el" :style="{ maxHeight: isOpen ? `${contentHeight}px` : 0 }">
    <slot name="content" />
  </div>
</template>

<style lang="scss" scoped>
button {
  padding-left: rem-calc(9);
  padding-right: rem-calc(13);
}
</style>
